import { ReactNode } from 'react';

import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  styled,
  SxProps,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { nimbleTheme } from 'theme';

export interface AccordionProps {
  children: ReactNode;
  defaultExpanded?: boolean;
  disabled?: boolean;
  title: string | ReactNode;
  dataTestId: string;
  sx?: SxProps;
  summarySx?: SxProps;
  expandIcon?: ReactNode;
  disableGutters?: boolean;
  onChange?: () => void;
  detailsSx?: SxProps;
}

export const Accordion: React.FC<AccordionProps> = ({
  children,
  defaultExpanded,
  disabled,
  disableGutters,
  title,
  dataTestId,
  onChange,
  sx,
  summarySx,
  expandIcon,
  detailsSx,
}) => {
  return (
    <MuiAccordion
      data-testid={dataTestId}
      defaultExpanded={defaultExpanded}
      disabled={disabled}
      sx={{ ...sx, boxShadow: 'none' }}
      disableGutters={disableGutters}
      onChange={onChange}
    >
      <StyledAccordionSummary
        expandIcon={expandIcon ? expandIcon : <ExpandMoreIcon data-testid="expansion-icon" />}
        data-testid={'accordion-title'}
        sx={summarySx}
      >
        {title}
      </StyledAccordionSummary>
      <StyledAccordionDetails sx={detailsSx} data-testid="accordion-details">
        {children}
      </StyledAccordionDetails>
    </MuiAccordion>
  );
};

const StyledAccordionDetails = styled(AccordionDetails)({
  color: nimbleTheme.palette.text.light,
  lineHeight: nimbleTheme.spacing(3),
});

const StyledAccordionSummary = styled(AccordionSummary)({
  fontWeight: 500,
  lineHeight: nimbleTheme.spacing(3),
});
